import React, { useState } from 'react';
import BaseModal from '../utils/BaseModal/BaseModal';
import {
  ButtonWrapper,
  CloseButton,
  Container,
  Footer,
  ListContainer,
  ListItem,
  ListItemColumn,
  ListItemRow,
  LoaderContainer,
  MediaCountRow,
  MediaCountText,
} from './AddMediaToFolderModal.styles';
import { useSelector } from 'react-redux';
import { selectAssetFolderActionsPending, selectFetchAssetFoldersInfo } from '../../../store/slices/assetFolder/slice';
import Spinner from '../../Spinner/Spinner';
import { Text16Regular } from '../../utils/Text/Text.styles';
import { ReactComponent as ImageIcon } from '../../../assets/icons/image-04.svg';
import { ReactComponent as VideoRecorderIcon } from '../../../assets/icons/video-recorder.svg';
import { ReactComponent as CheckCircleEmptyIcon } from '../../../assets/icons/check-circle-empty.svg';
import { ReactComponent as CheckCircleIcon } from '../../../assets/icons/check-circle-broken.svg';
import { Button } from '../../utils/Button/Button';

const AddMediaToFolderModal = ({ modalRef, onAdd }) => {
  const [selectedFolder, setSelectedFolder] = useState(null);
  const { data, pending } = useSelector(selectFetchAssetFoldersInfo);
  const { addMediaToAssetFolder: addMediaToAssetFolderPending } = useSelector(selectAssetFolderActionsPending);

  return (
    <BaseModal
      title="Add to"
      ref={modalRef}
      onClose={() => {
        modalRef.current.hide();
      }}
      onAfterClose={() => {}}>
      <Container>
        {pending ? (
          <LoaderContainer>
            <Spinner width={120} height={120} />
          </LoaderContainer>
        ) : (
          <ListContainer>
            {data.map(folder => {
              return (
                <ListItem
                  key={folder.id}
                  $selected={folder.id === selectedFolder?.id}
                  onClick={() => {
                    setSelectedFolder(folder);
                  }}>
                  <ListItemColumn>
                    <ListItemRow>
                      <Text16Regular>{folder.name}</Text16Regular>
                    </ListItemRow>
                    <ListItemRow>
                      <MediaCountRow>
                        <ImageIcon color="#9DA4AE" height={18} width={18} />
                        <MediaCountText>{folder.numOfPhotos}</MediaCountText>
                      </MediaCountRow>
                      <MediaCountRow>
                        <VideoRecorderIcon color="#9DA4AE" height={18} width={18} />
                        <MediaCountText>{folder.numOfVideos}</MediaCountText>
                      </MediaCountRow>
                    </ListItemRow>
                  </ListItemColumn>
                  {folder.id === selectedFolder?.id ? (
                    <CheckCircleIcon color="#1672BA" width={24} height={24} />
                  ) : (
                    <CheckCircleEmptyIcon color="#1672BA" width={24} height={24} />
                  )}
                </ListItem>
              );
            })}
          </ListContainer>
        )}
        <Footer>
          <CloseButton
            onClick={() => {
              modalRef.current.hide();
            }}>
            Close
          </CloseButton>
          <ButtonWrapper>
            <Button
              title="Add"
              disabled={!selectedFolder}
              isLoading={addMediaToAssetFolderPending}
              onClick={() => {
                onAdd(selectedFolder);
              }}
            />
          </ButtonWrapper>
        </Footer>
      </Container>
    </BaseModal>
  );
};

export default AddMediaToFolderModal;
